import { supabase } from '../supabaseClient'
import {
  EvaluacionTareaNioshInput,
  ResultadoTareaNiosh,
  ResultadoMultitareaNiosh,
} from './niosh'

// ===== Evaluaciones NIOSH por local/puesto de trabajo (multi-empresa) =====
// Mismo patrón que gestion-tecnica-reba.ts / reba_assessments: inputs y
// resultado se guardan como jsonb libre, tipados aquí para que el resto del
// código (formulario, PDF) no maneje `any`. A diferencia de REBA/RULA
// (una sola postura por evaluación), NIOSH es multitarea: cada evaluación
// guarda un arreglo de tareas y el resultado del Índice de Levantamiento
// Compuesto que las combina.

export interface NioshTareaGuardada {
  id: string
  input: EvaluacionTareaNioshInput
  resultado: ResultadoTareaNiosh
}

export interface NioshAssessmentRow {
  id: string
  company_id: string
  job_position_id: string | null
  descripcion: string
  tareas: NioshTareaGuardada[]
  resultado_compuesto: ResultadoMultitareaNiosh
  created_by: string | null
  created_at: string
  job_position_name: string | null
}

export interface CreateNioshAssessmentInput {
  companyId: string
  jobPositionId?: string
  descripcion: string
  tareas: NioshTareaGuardada[]
  resultadoCompuesto: ResultadoMultitareaNiosh
  createdBy: string | null
}

export async function createNioshAssessment(input: CreateNioshAssessmentInput): Promise<void> {
  const { error } = await supabase.from('niosh_assessments').insert({
    company_id: input.companyId,
    job_position_id: input.jobPositionId ?? null,
    descripcion: input.descripcion,
    tareas: input.tareas,
    resultado_compuesto: input.resultadoCompuesto,
    created_by: input.createdBy,
  })
  if (error) throw error
}

export async function fetchNioshAssessments(companyId: string): Promise<NioshAssessmentRow[]> {
  if (!companyId) return []
  const { data, error } = await supabase
    .from('niosh_assessments')
    .select('id, company_id, job_position_id, descripcion, tareas, resultado_compuesto, created_by, created_at, job_positions(name)')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map((r: any) => ({
    id: r.id,
    company_id: r.company_id,
    job_position_id: r.job_position_id,
    descripcion: r.descripcion,
    tareas: r.tareas,
    resultado_compuesto: r.resultado_compuesto,
    created_by: r.created_by,
    created_at: r.created_at,
    job_position_name: r.job_positions?.name ?? null,
  })) as NioshAssessmentRow[]
}
